module.exports = "<svg viewBox=\"0 0 14 11\"><path d=\"M13.32,4.97L8.99,0.64c-0.29-0.29-0.77-0.29-1.06,0s-0.29,0.77,0,1.06l2.97,2.97H1.21 C0.8,4.67,0.46,5,0.46,5.42S0.8,6.17,1.21,6.17h9.85L7.93,9.3c-0.29,0.29-0.29,0.77,0,1.06c0.15,0.15,0.34,0.22,0.53,0.22 s0.38-0.07,0.53-0.22l4.33-4.33C13.61,5.74,13.61,5.26,13.32,4.97z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/fill/fullArrowRight.svg
// module id = 627
// module chunks = 0 1